import { callChatbotApi } from 'Actions/commonAction/ChatbotAction';
import React, { useEffect, useRef } from 'react'
import { Card } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { call_chatbot_api, chat_onchange_input, chat_rating, feedback_popup } from 'Slices/commonSlices/Chatbot_slice';
import Icons from 'utils/Icons'
import images from 'utils/images'
import Rating from './Rating';
import { Link } from 'react-router-dom';
import parse from "html-react-parser";
import DotLoader from 'components/Button/DotLoader';
import { useCommonState, useCustomNavigate } from 'ReusableFunctions/CustomHooks';
import Cookies from 'js-cookie';

const Chatbot = () => {
    const { commonState, chatBotState } = useCommonState();
    const pageRender = useCustomNavigate();
    const dispatch = useDispatch();
    const chatbotRef = useRef();

    useEffect(() => {
        if (chatBotState?.logout_from) {
            initialChatbot('skip', '', 0, "closechat");
            pageRender("/");
        }
    }, [chatBotState?.logout_from])

    function initialChatbot(chat_flag, user_selected_message, rating, closechat) {
        let random_session_id = chatBotState?.random_session_id;
        let message = (chatBotState?.chat_input || user_selected_message || '')?.trim();

        if (chat_flag === 'minimize') return dispatch(call_chatbot_api({ type: 'minimize_chatbot', show: true }))
        if (chat_flag === 'maximaize') return dispatch(call_chatbot_api({ type: 'minimize_chatbot', show: false }))
        if (chat_flag === 'init') random_session_id = Math.floor(Math.random() * (9999999999 - 1000000000 + 1)) + 1000000000;
        if (['close', 'step', 'skip'].includes(chat_flag) && !random_session_id) return
        if (chat_flag === 'step' && !message) return toast.error("Input should not be empty")
        if (chat_flag === 'close' && !rating && !closechat) return dispatch(feedback_popup(true))
        if (chat_flag === 'close' && !rating && closechat) return toast.error("please rate the chatbot")
        if (chat_flag === 'skip') {
            chat_flag = 'close'
            rating = 0;
        }

        dispatch(callChatbotApi({
            session_id: random_session_id,
            flag: chat_flag,
            msg: chatBotState?.user_feedback_popup ? '' : message,
            feedback: chatBotState?.user_feedback_popup ? message : '',
            plan: chatBotState?.user_data?.pricing_category,
            email_id: chatBotState?.user_data?.email_id,
            show_chatbot_widget: chat_flag === 'close' ? false : true,
            rating
        }))
    }

    useEffect(() => {
        if (chatbotRef.current) chatbotRef.current.scrollTop = chatbotRef.current.scrollHeight
    }, [chatBotState?.chat_message, chatBotState?.show_chatbot_widget])

    useEffect(() => {
        if (chatBotState?.user_data?.payment_status === "trialing" && window.location.pathname.includes("employer_dashboard")) return
        if (chatBotState?.show_chatbot_widget && chatBotState?.Logged_in_show_chatbot && chatBotState?.user_data?.email_id) initialChatbot('init')
    }, [chatBotState?.show_chatbot_widget, chatBotState?.Logged_in_show_chatbot, chatBotState?.user_data?.email_id])

    function cleanHtmlString(htmlString) {
        return htmlString
            .replace(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g, '<a href="$2">$1</a>')
            .replace(/^```[a-zA-Z]*\s*\n?/, "") // Remove starting ```html\n or ```\n
            .replace(/\n?```$/, "")             // Remove ending ```
            .trim();                            // Trim any extra spaces or newlines
    }

    function processText(htmlString) {
        const baseUrl = process.env.REACT_APP_SHARE_BASEURL || "";
        const cleanedHtml = cleanHtmlString(htmlString)

        return (
            <>
                {parse(cleanedHtml, {
                    replace: (domNode) => {
                        if (domNode.name === "a" && domNode.attribs && domNode.attribs.href) {
                            const href = domNode.attribs.href;

                            const innerContent = domNode.children
                                ? domNode.children.map((child, index) => {
                                    if (child.type === "text") {
                                        return child.data;
                                    } else if (child.type === "tag") {
                                        const childContent = child.children
                                            ? child.children.map((c) => (c.type === "text" ? c.data : parse(c))).join("")
                                            : "";

                                        return parse(`<${child.name}>${childContent}</${child.name}>`);
                                    }
                                    return null;
                                })
                                : null;

                            // Convert internal links to <Link>
                            if (baseUrl && href.startsWith(baseUrl)) {
                                return (
                                    <Link key={href} to={href.replace(baseUrl, "")} target='_self' rel="noreferrer">
                                        {innerContent}
                                    </Link>
                                );
                            }

                            // Keep <a> for external links
                            return (
                                <a key={href} href={href} target="_blank" rel="noreferrer">
                                    {innerContent}
                                </a>
                            );
                        }

                        if (domNode.name === "button") {
                            const innerContent = domNode.children
                                ? domNode.children
                                    .map((child) => (child.type === "text" ? child.data : ""))
                                    .join("")
                                : "";

                            return (
                                <button
                                    onClick={() => initialChatbot("step", innerContent)}
                                    className="btn custom_response_button w-100 rounded-4"
                                >
                                    {innerContent}
                                </button>
                            );
                        }

                    },
                })}
            </>
        );
    }

    function chatButtonClass() {
        let url_pathname = window.location.pathname.split('/')[window.location.pathname.split('/')?.length - 1];

        switch (url_pathname) {
            case 'all_jobs':
                return commonState?.innerWidth <= 1400 ? "chatbot_button_reuse" : "chatbot_button_professional"

            case 'pool':
                return "chatbot_button_pool"

            default:
                return "chatbot_button_professional"
        }
    }

    function chatCardClass() {
        let url_pathname = window.location.pathname.split('/')[window.location.pathname.split('/')?.length - 1];

        switch (url_pathname) {
            case 'all_jobs':
                return commonState?.innerWidth <= 1400 ? "employer_or_partner_widget" : ""

            case 'pool':
                return "employer_or_partner_pool_widget"

            default:
                return ""
        }
    }

    function isTourGuideOpened() {
        return Cookies.get("isEmployerFirstVisit") || Cookies.get("isEmployerPoolFirstVisit") || Cookies.get("isFirstVisit") || Cookies.get("isFirstVisitProfile") || Cookies.get("isFirstVisitProfileParsing");
    }

    return (
        <React.Fragment>
            <div className={`${chatBotState?.show_chatbot_widget ? 'chatbot_widget' : 'd-none'}`}>
                <div className={`chatbot_widget_card ${chatCardClass()}`}>
                    <div className="chatbot_widget_header ps-4 d-flex align-items-center">
                        <img src={images?.chatbot_logo} width="40rem" height="40rem" alt='chatbot_logo' className='chatbot_logo' />
                        <h2 className='m-0 text-start ps-2 col-8'>Navi here, your personal 2nd Careers guide</h2>

                        <div className='chatbot_minimize_button'>
                            <button type="button" className='btn btn-sm text-primary border-0' onClick={() => initialChatbot(chatBotState?.show_chatbot_widget ? 'close' : 'init')}>
                                {Icons?.close_icon}
                            </button>
                        </div>
                        <div className="design">
                            {Icons?.chatbot_header_design}
                        </div>
                    </div>

                    <div className="chatbot_widget_body" ref={chatbotRef}>
                        <div className="row">
                            {
                                chatBotState?.chat_message?.map((item, index) => (
                                    item?.conversation_by === 'bot' ?
                                        item?.is_dumbledoor_thinking ?
                                            <div className="col-12 mb-2" key={index}>
                                                <div className="col-11 d-flex">
                                                    <img src={images?.chatbot_logo} width="38rem" height="38rem" alt='chatbot_logo' className='chatbot_logo' />
                                                    <div className="col ps-1 mt-2">
                                                        <div className="chatbot_bot_card">
                                                            Thinking
                                                            <span className='d-inline-block ps-1'>
                                                                <DotLoader />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="col-12 mb-2" key={index}>
                                                <div className="col-11 d-flex">
                                                    <img src={images?.chatbot_logo} width="38rem" height="38rem" alt='chatbot_logo' className='chatbot_logo' />
                                                    <div className="col ps-1 mt-2">
                                                        <div className="chatbot_bot_card">
                                                            {processText(item?.message)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        :
                                        <div className="col-12 mb-2" key={index}>
                                            <div className="col-11 d-flex align-items-end ms-auto">
                                                <div className="col ps-1">
                                                    <div className="chatbot_user_card">
                                                        {item?.message}
                                                    </div>
                                                </div>
                                                <img src={process.env.REACT_APP_SECOND_CAREERS_CDN + chatBotState?.user_data?.profile_image} width="38rem" height="38rem" alt='chatbot_logo' className='chatbot_logo' />
                                            </div>
                                        </div>
                                ))
                            }
                        </div>
                    </div>

                    <div className='chatbot_widget_footer px-4 '>
                        <div className='row'>
                            <div className="col-10 pe-0">
                                <textarea
                                    className='form-control chatbot_input_textarea'
                                    placeholder='Type your message here'
                                    cols={2}
                                    value={chatBotState?.user_feedback_popup ? '' : chatBotState?.chat_input}
                                    onChange={(e) => dispatch(chat_onchange_input(e.target.value))}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" && e.shiftKey) return;
                                        if (e.key === "Enter" && !chatBotState?.getting_chatbot_response) {
                                            e.preventDefault();
                                            initialChatbot('step');
                                        }
                                    }}
                                    autoFocus
                                />
                            </div>

                            <button
                                type="button"
                                className={`${chatBotState?.getting_chatbot_response ? 'pe-none' : ''} btn w-100 bg-light chatbot_Send_button`}
                                onClick={() => initialChatbot('step')}
                                id="chatbot_send_button" >

                                {Icons?.chatbot_send_icon}
                            </button>
                        </div>
                    </div>

                    <div className={chatBotState?.user_feedback_popup ? "chatbot_rating" : "d-none"}>
                        <Card className="chatbot_rating_body col-10 rounded-3">
                            <Card.Header className='d-flex'>
                                <div className="col-11">
                                    <p className='mb-0'>Feedback and ratings</p>
                                </div>
                                <div className="col">
                                    <button type="button" className='btn-close' onClick={() => dispatch(feedback_popup(false))}></button>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="col mb-3">
                                    <h6>Ratings:</h6>
                                    <Rating maxStars={5} onRate={(rating) => dispatch(chat_rating(rating))} rated={chatBotState?.chat_rating} />
                                </div>

                                <div className="col">
                                    <h6>Feedback:</h6>
                                    <textarea className='form-control mt-2' placeholder='Write your feedback here' rows={6} value={chatBotState?.chat_input || ''} onChange={(e) => dispatch(chat_onchange_input(e.target.value))} />
                                </div>

                                <div className="row">
                                    <div className="col p-2">
                                        <button type="button" className='btn btn-outline-primary mt-3 w-100' onClick={() => initialChatbot('skip', chatBotState?.chat_input, chatBotState?.chat_rating, "closechat")}>
                                            Skip
                                        </button>
                                    </div>
                                    <div className="col p-2">
                                        <button type="button" className='btn btn-primary mt-3 w-100' onClick={() => initialChatbot('close', chatBotState?.chat_input, chatBotState?.chat_rating, "closechat")}>
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </div>

            <div className={chatButtonClass()} id="chatbot_button"> {/* style={{ zIndex: isTourGuideOpened() ? 0 : 1061 }} */}
                <button
                    type="button"
                    className='btn btn-primary'
                    onClick={
                        () => initialChatbot(chatBotState?.minimize_chatbot ?
                            'maximaize'
                            :
                            !chatBotState?.random_session_id ?
                                chatBotState?.show_chatbot_widget ? 'close' : 'init'
                                :
                                'minimize'
                        )
                    }
                    disabled={!chatBotState?.user_data?.email_id || chatBotState?.Logged_in_show_chatbot}
                >
                    {
                        chatBotState?.show_chatbot_widget ?
                            Icons?.minimize_icon
                            :
                            Icons?.chatbot_icon
                    }
                </button>
            </div>

        </React.Fragment >
    )
}

export default Chatbot